module.exports = __webpack_public_path__ + "static/media/S1N2-1.00f67404.svg";